import colors from '../config/colors.json'
import { findMap } from '../helpers/drafting'
import { useSocketEvent, useSocketState } from '../helpers/useSocket'
import { useState } from 'react'
import 'chart.js/auto'

export default function LiveGame() {
	const [match] = useSocketState('Match')
	const [config, setConfig] = useState({})

	useSocketEvent('updateConfig', (newdata) => {
		console.log(`Received updateConfig`, newdata)
		setConfig(newdata)
	})

	if (!match) return <div />

	const flipPlayers = match.flipPlayersIngame

	const leftPlayer = !flipPlayers ? match.leftPlayer : match.rightPlayer
	const rightPlayer = flipPlayers ? match.leftPlayer : match.rightPlayer

	const leftColor = colors[leftPlayer.color]
	const rightColor = colors[rightPlayer.color]
	const leftScore = leftPlayer.score
	const rightScore = rightPlayer.score

	document.body.style.overflow = 'hidden'

	const mapDetails = findMap(
		match.games.filter((v) => v.state === 'upcoming').reverse()[0]?.map,
	)

	return (
		<div
			className="livegame"
			style={{
				'--left-player-color': leftColor?.mainColor,
				'--left-player-color-secondary': leftColor.secondaryColor,
				'--right-player-color': rightColor?.mainColor,
				'--right-player-color-secondary': rightColor?.secondaryColor,
			}}
		>
			<link
				rel="stylesheet"
				type="text/css"
				href={`/themes/${config.cssTheme}`}
			/>

			<div className="ingameScoreWrapper">
				<div className="scoreContainer score-leftScore">
					<h1>{leftScore}</h1>
				</div>
				<div className="scoreContainer score-rightScore">
					<h1>{rightScore}</h1>
				</div>
			</div>

			<div className="ingameScoreColor">
				<div className={`scoreBannerWrapper-left`}>
					<div className="scoreBanner-img scoreBanner-left"> </div>
					<div
						className={`scoreBannerColorOverlay scoreBannerColorOverlay-${leftPlayer.color}-left`}
					></div>
				</div>
				<div className={`scoreBannerWrapper-right`}>
					<div className="scoreBanner-img scoreBanner-right"> </div>
					<div
						className={`scoreBannerColorOverlay scoreBannerColorOverlay-${rightPlayer.color}-right `}
					></div>
				</div>
			</div>

			<div className="minimapWrapper">
				<div className="minimapMatchType">
					{match.matchType.replace(' - ABBA', '')}
				</div>
				{mapDetails && (
					<div className="minimapMapName">{mapDetails.label}</div>
				)}
				<div className="minimapRoundInfo hidden">{match.roundInfo}</div>
			</div>
		</div>
	)
}
